import { http, HttpResponse } from 'msw';

import {
  getOptionContract,
  getContractsChain,
  getOptionStrategies,
  getUnderlyingEndDates,
  getUnderlyingAssetIsins,
  getFrozenHistory,
} from '@core/option';

import { Storage } from '../storage';
import { parseUrl } from '../utils';
import endDatesData from '../data/option/end-dates.json';
import contractsData from '../data/option/contracts.json';
import strategiesData from '../data/option/strategies.json';
import contractsChainData from '../data/option/contracts-chain.json';
import underlyingAssetIsinData from '../data/option/underlying-asset-isin.json';
import frozenHistoryData from '../data/option/frozen-history.json';

type TGetContracts = HttpGet<typeof getOptionContract>;
type TGetContractsChain = HttpGet<typeof getContractsChain>;
type TGetFrozenHistory = HttpGet<typeof getFrozenHistory>;
type TGetOptionStrategies = HttpGet<typeof getOptionStrategies>;
type TGetUnderlyingEndDates = HttpGet<typeof getUnderlyingEndDates>;
type TGetUnderlyingAssetIsins = HttpGet<typeof getUnderlyingAssetIsins>;

export const optionStrategiesStorage = new Storage(
  'optionStrategies',
  strategiesData
);

export default [
  http.get<
    TGetUnderlyingAssetIsins[0],
    TGetUnderlyingAssetIsins[1],
    TGetUnderlyingAssetIsins[2]
  >(parseUrl(getUnderlyingAssetIsins.url), () => {
    return HttpResponse.json(underlyingAssetIsinData);
  }),
  http.get<
    TGetUnderlyingEndDates[0],
    TGetUnderlyingEndDates[1],
    TGetUnderlyingEndDates[2]
  >(parseUrl(getUnderlyingEndDates.url), () => {
    return HttpResponse.json(endDatesData);
  }),
  http.get<TGetContractsChain[0], TGetContractsChain[1], TGetContractsChain[2]>(
    parseUrl(getContractsChain.url),
    async ({ request }) => {
      const url = new URL(request.url);
      const params = url.searchParams;

      const endDate = params.get('endDate') as string;
      const underlyingAssetIsin = params.get('underlyingAssetIsin') as string;

      return HttpResponse.json({
        ...contractsChainData,
        endDate,
        underlyingInstrumentIsin: underlyingAssetIsin,
      });
    }
  ),
  http.get<TGetContracts[0], TGetContracts[1], TGetContracts[2]>(
    parseUrl(getOptionContract.url),
    ({ params }) => {
      const { isin } = params;
      return HttpResponse.json({ ...contractsData, isin });
    }
  ),
  http.get<TGetFrozenHistory[0], TGetFrozenHistory[1]>(
    parseUrl(getFrozenHistory.url),
    () => {
      return HttpResponse.json(frozenHistoryData);
    }
  ),
  http.get<
    TGetOptionStrategies[0],
    TGetOptionStrategies[1],
    TGetOptionStrategies[2]
  >(parseUrl(getOptionStrategies.url), () => {
    const data = optionStrategiesStorage.getValue();
    return HttpResponse.json(data);
  }),
];
